import Cookies from 'js-cookie';
import { jwtDecode } from "jwt-decode";

export const checkTokenExpiration = () => {
    const token = Cookies.get('token');
    if (token) {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
            return true;
        }
    }
    return false;
};
